
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "../../styles/ConnexionPage.css";

export default function ConnexionPage() {

    const { t } = useTranslation();

    return (
        <section className="connexion-page">
            <Link to="/login" className="connexion-link">
                {t("connexion.signIn")}
            </Link>
        </section>
    );
}

